export default "__VITE_ASSET__AEXyJaY3__"